"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
// Original source - https://code.amazon.com/packages/CAPWebsiteFrontend/blobs/mainline/--/packages/website/src/intl/puffjToICU.js
const localeToTranslationsMap_1 = __importDefault(require("./localeToTranslationsMap"));
const puffToICU_1 = require("./puffToICU");
const DEFAULT_LOCALE = 'en-US';
/**
 * Function to retrieve all translations for a locale
 * @param {string} locale
 * @return raw translations without intl formatting
 */
const getTranslations = async (locale) => {
    let translations = {};
    if (!locale || !localeToTranslationsMap_1.default[locale]) {
        translations = await localeToTranslationsMap_1.default[DEFAULT_LOCALE]();
    }
    else {
        translations = await localeToTranslationsMap_1.default[locale]();
    }
    const icu = (0, puffToICU_1.toICUMessages)(translations);
    return icu;
};
exports.default = getTranslations;
//# sourceMappingURL=getTranslations.js.map